/* @sravni/react-design-system version 0.2.65 */
import * as React from 'react';
import { useStyles, safeInvoke, noop } from '@sravni/react-utils';
import { Star as Star$1 } from '@sravni/react-icons';
import '../../Icon/index.js';
import modules_d76667db from '../styles/Rate.module.less.js';
import Icon from '../../Icon/src/Icon.js';

var Star = function (props) {
    var _a, _b;
    var className = props.className, index = props.index, value = props.value, size = props.size, allowHalf = props.allowHalf, disabled = props.disabled, onClick = props.onClick, onHover = props.onHover;
    var thirdFilled = value && value > index;
    var halfFilled = value && value > index + 0.3;
    var threeQuartersFilled = value && value > index + 0.5;
    var fullFilled = value && value > index + 0.8;
    var focusedSecond = value && value >= index + 1;
    var cx = useStyles(modules_d76667db);
    var classNames = cx(className, 'starContainer', {
        disabled: disabled,
    });
    var starClassNames = cx('star', (_a = {
            disabled: disabled
        },
        _a["size-" + size] = size,
        _a.fill = focusedSecond,
        _a));
    var halfStarClassNames = cx('star', 'half', (_b = {
            disabled: disabled
        },
        _b["half-" + size] = size,
        _b['thirdFilled'] = thirdFilled,
        _b['halfFilled'] = halfFilled,
        _b['threeQuartersFilled'] = threeQuartersFilled,
        _b['fullFilled'] = fullFilled,
        _b.fill = thirdFilled || halfFilled || threeQuartersFilled || fullFilled,
        _b));
    var handleClick = React.useCallback(function (event) {
        safeInvoke(onClick, event, index);
    }, [index, onClick]);
    var handleHover = React.useCallback(function (event) {
        safeInvoke(onHover, event, index);
    }, [index, onHover]);
    return (React.createElement("div", { className: classNames, onClick: disabled ? noop : handleClick, onMouseMove: disabled ? noop : handleHover },
        allowHalf ? React.createElement(Icon, { className: halfStarClassNames, icon: React.createElement(Star$1, null) }) : null,
        React.createElement(Icon, { className: starClassNames, icon: React.createElement(Star$1, null) })));
};
Star.displayName = 'Star';

export default Star;
//# sourceMappingURL=Star.js.map
